import { Post, DummyPlainObject} from './Post';
import { PostList } from './PostList';


export class ThreadPost extends Post {
  public constructor(private _id: string, private _content: string, private _username: string, private _timestamp: Date) {
    super();
  }

  public get id():string{
    return this._id;
  }
  public get content(): string {
    return this._content;
  }
  public get username(): string {
    return this._username;
  }
  public get timestamp(): Date {
    return this._timestamp;
  }
  public get responseCount(): number {
    return 0;
  }
  public get lastUpdate(): Date {
    return this.timestamp;
  }
  public get ymd(): string {
    const year = this.timestamp.getFullYear();
    const month = ('00' + (this.timestamp.getMonth() + 1)).slice(-2);
    const day = ('00' + this.timestamp.getDate()).slice(-2);
    return year + '/' + month + '/' + day;
  }
  public get hi(): string {
    var hh = ('00' + this.timestamp.getHours()).slice(-2);
    var mm = ('00' + this.timestamp.getMinutes()).slice(-2);
    return hh + ':' + mm;
  }
  public hasChildren(): boolean {
    return false;
  }
  get postList(): PostList<Post> {
    throw new Error("Method not implemented.");
  }

  public toPlainObject(): Object {
    const plainObject: DummyPlainObject = {
      id: this.id,
      contents: this.content,
      username: this.username,
      timestamp: this.timestamp,
    };

    return plainObject;
  }
}